import { render } from "./centralita.vue?vue&type=template&id=54fdf136&scoped=true"
import script from "./centralita.vue?vue&type=script&lang=js"
export * from "./centralita.vue?vue&type=script&lang=js"

import "./centralita.vue?vue&type=style&index=0&id=54fdf136&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fdf136"]])

export default __exports__